module.exports = __webpack_public_path__ + "img/how-to-register.e756cad.png";